import { render } from "./App.vue?vue&type=template&id=944fc090"
const script = {}

import "./App.vue?vue&type=style&index=0&id=944fc090&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__